module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_10-7633d819542b0a400342ff9d9da9cccb.jpeg";